// extracted by mini-css-extract-plugin
module.exports = {"author":"ItemAuthor_author__3YDHC","content":"ItemAuthor_content__3ZLbD","avatar":"ItemAuthor_avatar__6EgkJ","details":"ItemAuthor_details__2-ZkP"};